<template>
  <div class="vue timparty-porta-un-amico bg-dark pb-5 mgm-bg mgm">
    <div class="container text-white mb-5" v-if="!flgEndInitiative">
      <div class="row">
<!--        <div class="col-sm-12 mb-2 mt-2">-->
<!--          <a href="/homepage" class="text-white">Home Page</a> > <span>Porta un amico</span>-->
<!--        </div>-->

        <porta-un-amico-referral v-if="showBanner"></porta-un-amico-referral>
        <div class="col-12 text-center justify-content-center d-flex align-items">
<!--          <img src="/themes/custom/timparty/images/portaunamico-red-yellow2.png" class="fit-image">-->
          <div>
            <div class="text-center col-sm-12" style="margin-bottom: 100px;">
              <div class="d-flex justify-content-center mt-3">
                <h1 class="mb-lg-5 mb-3 subtitle">
                  {{ __('Porta un amico') }}
                </h1>
                <div>
                  <button-badges-modal :custom-contest-active="customContestPresentatore.active"
                                       :custom-contest-html="customContestPresentatore.html"
                                       :custom-contest-image="customContestPresentatore.image">
                  </button-badges-modal>
                </div>
              </div>
              <div class="justify-content-center mb-4">
                  <p class="small-text">SCADE TRA</p>
                  <div class="digit-block mx-1 mx-lg-3" v-if="leftTime.days.firstNumber > 0 || leftTime.days.secondNumber > 0 || leftTime.days.thirdNumber > 0">
                    <div class="mb-2">
                      <span class="porta-un-amico-timer-digit border border-secondary px-2 py-1" v-if="leftTime.days.thirdNumber > 0">{{ leftTime.days.thirdNumber }}</span>
                      <span class="porta-un-amico-timer-digit border border-secondary px-2 py-1 mx-1">{{ leftTime.days.firstNumber }}</span>
                      <span class="porta-un-amico-timer-digit border border-secondary px-2 py-1">{{ leftTime.days.secondNumber }}</span>
                    </div>
                    <p class="time-text">GIORNI</p>
                  </div>
                  <div class="digit-block mx-1 mx-lg-3">
                    <div class="mb-2">
                      <span class="porta-un-amico-timer-digit border border-secondary px-2 py-1 mx-1">{{ leftTime.hours.firstNumber }}</span>
                      <span class="porta-un-amico-timer-digit border border-secondary px-2 py-1 mx-1">{{ leftTime.hours.secondNumber }}</span>
                    </div>
                    <p class="time-text">ORE</p>
                  </div>
                  <div class="digit-block mx-1 mx-lg-3">
                    <div class="mb-2">
                      <span class="porta-un-amico-timer-digit border border-secondary px-2 py-1 mx-1">{{ leftTime.minutes.firstNumber }}</span>
                      <span class="porta-un-amico-timer-digit border border-secondary px-2 py-1 mx-1">{{ leftTime.minutes.secondNumber }}</span>
                    </div>
                    <p class="time-text">MINUTI</p>
                  </div>
                  <div class="digit-block mx-1 mx-lg-3" v-if="leftTime.days.firstNumber == 0 && leftTime.days.secondNumber == 0">
                    <div class="mb-2">
                      <span class="porta-un-amico-timer-digit border border-secondary px-2 py-1 mx-1">{{ leftTime.seconds.firstNumber }}</span>
                      <span class="porta-un-amico-timer-digit border border-secondary px-2 py-1 mx-1">{{ leftTime.seconds.secondNumber }}</span>
                    </div>
                    <p class="time-text">SECONDI</p>
                  </div>
              </div>
              <h3 class="mb-4 subtitle">
                {{ __('Tanti vantaggi esclusivi vi aspettano') }}
              </h3>
<!--              <p class="mb-4">{{ __('Esperienze 2X1, Offerte TIM uniche e tanti Badge extra') }}</p>-->
              <ul class="text-left porta-un-amico-ul">
                <li class="mb-3 d-flex"><div>Invia il <span class="yellow-text">Codice Amico</span> ai tuoi amici e invitali su TIM Party entro il <span v-text="formatTimestamp(initiative.initiativeMgm.endTime)"></span>, termine iniziativa</div></li>
                <li class="mb-3 d-flex"><div>I tuoi amici hanno <span class="yellow-text" v-text="initiative.initiativeMgm.subscriptionDays"></span>
                  <span class="yellow-text" v-if="initiative.initiativeMgm.subscriptionDays == 1"> giorno</span>
                  <span class="yellow-text" v-else> giorni</span>
                  dal loro primo accesso a TIM Party per utilizzare il Codice Amico e comunque entro il termine dell’iniziativa</div></li>
                <li class="mb-3 d-flex"><div>Una volta inserito il Codice Amico, sarà disponibile <span class="yellow-text">un esclusivo vantaggio</span> per te e per i tuoi amici</div></li>
                <li class="d-flex"><div>Riceverai un vantaggio per ciascun amico che porterai in TIM Party, fino ad un <span class="yellow-text">massimo di </span><span class="yellow-text" v-text="initiative.userInformation.maxBurn"></span></div></li>
              </ul>
              <h4 class="text-white mt-5">Invia subito il tuo Codice Amico</h4>
              <div class="d-inline-block d-lg-flex justify-content-center">
                <div class="d-inline-block align-bottom boxes">
                  <p class="mb-0 align-left text-uppercase yellow-codice-amico">Codice Amico</p>
                  <div class="btn py-2 px-4 yellow-box text-dark align-left codice-amico-code" v-text="initiative.userInformation.ownReferralCode"></div>
<!--                    <div class="btn py-2 px-5 yellow-box text-dark align-left codice-amico-code">123456</div>-->
                </div>
                <div class="btn py-3 px-5 btn-dark border-white border d-inline-block ml-lg-5 mt-3 align-bottom btn-copia-codice" @click.prevent="copyCode">
                  <b v-if="codeCopied === false">COPIA CODICE</b>
                  <b v-else>CODICE COPIATO!</b>
                </div>
                <div class="d-inline-block ml-lg-4 py-3 mt-lg-3">
                  oppure condividi con
                </div>
<!--                    <div class="d-inline-block ml-4 align-bottom">-->
<!--                      <a href="">-->
<!--                        <img src="/themes/custom/timparty/images/portaunamico-wp.png" alt="">-->
<!--                      </a>-->
<!--                    </div>-->
<!--                    <div class="d-inline-block ml-4 align-bottom">-->
<!--                      <a href="">-->
<!--                        <img src="/themes/custom/timparty/images/portaunamico-fb.png" alt="">-->
<!--                      </a>-->
<!--                    </div>-->
                  <share-buttons theme="mgm" :twitter-active=false :facebook-active=true label="" :mgm-referral-prize="refereeBenefit.title" :mgm-referral-code="initiative.userInformation.ownReferralCode" :text="'Entra in TIM Party! Inserisci il codice amico ' + initiative.userInformation.ownReferralCode + ' e otterrai subito un grande vantaggio: ' + refereeBenefit.title + ' ' + baseUrlShare +' #TIMParty #Portaunamico'"></share-buttons>
                </div>
<!--                <h3 class="text-white my-4">-->
<!--                  {{ __('L’iniziativa') }}-->
<!--                </h3>-->
<!--                <p class="">{{ __('Se non hai già richiesto i vantaggi, hai tempo fino al ') }} {{formatTimestamp(initiative.initiativeMgm.endTime) }}</p>-->
<!--                <p class="">{{ __('Se non hai già richiesto i vantaggi, hai tempo fino al ') }} 12/01/2021</p>-->
            </div>
            <div class="col-sm-12 text-center">
              <h3 class="text-white my-5">
                {{ __('I tuoi vantaggi') }}
              </h3>
              <h5 class="text-white" v-if="initiative.userInformation.points > 0">
                {{ __('Hai portato') }} <span class="border border-secondary py-1 px-3" v-text="initiative.userInformation.points"></span>
                <span v-if="initiative.userInformation.points == 1"> {{ __('amico') }}</span>
                <span v-else> {{ __('amici') }}</span>
              </h5>
              <h3 class="text-white my-5" v-else>
                {{ __('Non hai portato ancora nessun amico') }}
              </h3>

            </div>
          </div>
<!--          <img src="/themes/custom/timparty/images/portaunamico-blue2.png" class="fit-image ml-5">-->
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12">
          <porta-un-amico-carousel></porta-un-amico-carousel>
        </div>
        <div class="col-12 text-center">
          <h3 class="text-white my-4">
            {{ __('Il vantaggio per i tuoi amici') }}
          </h3>
        </div>
        <div class="col-12 text-center justify-content-center d-flex">
<!--          <img src="/themes/custom/timparty/images/portaunamico-blue3.png" alt="" class="fit-image">-->
          <div class="vantaggi-per-amici mx-3">
            <div class="row">
              <div class="col-lg-6 pr-lg-0 col-m-6 pl-m-3">
                <div class="benefit-image">
                  <img v-bind:src="refereeBenefit.image" class="img-fluid">
                </div>
              </div>
              <div class="col-lg-6 pl-lg-0 col-m-6 pl-m-3">
                <div class="benefit-description h-100">
                  <h5><b v-html="refereeBenefit.title"></b></h5>
                  <p v-html="refereeBenefit.description"></p>
                </div>
              </div>
            </div>
          </div>
<!--          <img src="/themes/custom/timparty/images/portaunamico-yellow3.png" alt="" class="fit-image">-->
        </div>
      </div>
      <basic-modal :modal-id="modal.modal_id"  modalClass="modal-lg" :show="modal.show" v-on:modalClose="modal.show = false;">

        <div class="modal-body p-5">
          <div class="text-center my-3">
            <img :src="modulePath('/js/src/assets/images/icon-teal-badge-xl.png')">
          </div>

          <div>
            <div class="text-center my-4">
              <h3 class="text-dark mt-2 font-weight-bold">Bonus Badge per Party Collection</h3>
            </div>

            <div class="text-left">
              <p>Complimenti, hai ottenuto il tuo Bonus Badge per partecipare al Concorso Party Collection.<br>
                Il tuo contatore è già stato aggiornato: puoi consultarlo in qualsiasi momento nell'apposita sezione.</p>
            </div>

            <div class="text-center my-4">
              <a id="link-badge" href="/party-collection-5" class="btn btn-lg btn-primary">VEDI I TUOI BADGE</a>
            </div>
          </div>
        </div>
      </basic-modal>
    </div>

    <!--      Check Fine iniziativa     -->
    <div class="container text-white mb-5" v-else-if="flgEndInitiative && !flgEndRedeemInitiative && redeemableRewards.length > 0">
<!--      <div class="row">-->
<!--        <div class="col-sm-12 mb-2 mt-2">-->
<!--          <a href="/homepage" class="text-white">Home Page</a> > <span>Porta un amico</span>-->
<!--        </div>-->
<!--      </div>-->
      <div class="text-center col-12 d-lg-flex row justify-content-center">
<!--        <img src="/themes/custom/timparty/images/portaunamico-red-yellow2.png" class="fit-image">-->
        <div>
          <div class="text-center col-sm-12 mt-3" style="margin-bottom: 100px;">
            <div class="d-flex justify-content-center row">
              <h1 class="mb-lg-5 mb-3 subtitle">
                {{ __('Porta un amico') }}
              </h1>
              <button-badges-modal :custom-contest-active="customContestPresentatore.active"
                                   :custom-contest-html="customContestPresentatore.html"
                                   :custom-contest-image="customContestPresentatore.image">
              </button-badges-modal>
            </div>

            <div class="col-sm-12 text-center">
              <h3 class="text-white my-5">
                {{ __("L’iniziativa è conclusa, ma puoi ancora richiedere i tuoi vantaggi") }}
              </h3>
            </div>
            <div class="col-sm-12 text-center">
              <p class="text-white my-5"
                 v-text="'Se non hai già richiesto i vantaggi, hai tempo fino al ' + formatTimestamp(initiative.initiativeMgm.redeemEndTime)">
              </p>
            </div>

          </div>
          <div class="col-sm-12 text-center">
            <h3 class="text-white my-5">
              {{ __('I tuoi vantaggi') }}
            </h3>
            <h5 class="text-white" v-if="initiative.userInformation.points > 0">
              {{ __('Hai portato') }} <span class="border border-secondary py-1 px-3" v-text="initiative.userInformation.points"></span>
              <span v-if="initiative.userInformation.points == 1"> {{ __('amico') }}</span>
              <span v-else> {{ __('amici') }}</span>
            </h5>
            <h3 class="text-white my-5" v-else>
              {{ __('Non hai portato ancora nessun amico') }}
            </h3>

          </div>
        </div>
<!--        <img src="/themes/custom/timparty/images/portaunamico-connettore_ciano6.png" class="fit-image ml-5">-->
      </div>

      <div class="row mt-4">
        <div class="col-12">
          <porta-un-amico-carousel></porta-un-amico-carousel>
        </div>
      </div>
    </div>

    <!--      Check Fine redenzione     -->
    <div class="container text-white mb-1" v-else-if="(flgEndInitiative && flgEndRedeemInitiative) || (flgEndInitiative && !flgEndRedeemInitiative && redeemableRewards.length === 0)">
<!--      <div class="row">-->
<!--        <div class="col-sm-12 mb-2 mt-2">-->
<!--          <a href="/homepage" class="text-white">Home Page</a> > <span>Porta un amico</span>-->
<!--        </div>-->
<!--      </div>-->
      <div class="text-center col-12 d-lg-flex justify-content-center">
        <div>
          <div class="text-center col-sm-12 mb-2">
            <div class="d-flex justify-content-center row">
              <h1 class="mb-lg-5 my-3 subtitle">
                {{ __('Porta un amico') }}
              </h1>
            </div>

            <div class="col-sm-12 text-center">
              <h3 class="text-white mt-5 mb-0">
                {{ __("L’iniziativa è conclusa") }}
              </h3>
            </div>
            <div class="col-sm-12 text-center">
              <p class="text-white my-5"
                 v-html="'Nuovi vantaggi e iniziative ti aspettano su TIM Party.<br>Per essere sempre aggiornato iscriviti alla newsletter.'">
              </p>
            </div>

          </div>
        </div>
      </div>
    </div>



    <div class="bg-navbar py-5" style="background-color: #0033a1" v-if="!showBanner">
      <div class="row row-eq-height">
        <div class="col-lg-8 offset-lg-2 p-5">
          <div class="box-contact h-100">
            <newsletter-box></newsletter-box>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import TimPartyMixin        from '../mixins/TimPartyMixin';
    import BasicModal           from "./BasicModal";
    import ButtonBadgesModal    from "./ButtonBadgesModal";
    import NewsletterBox        from "./NewsletterBox";
    import PortaUnAmicoCarousel from "./PortaUnAmicoCarousel";
    import PortaUnAmicoReferral from "./PortaUnAmicoReferral";
    import $                    from "jquery";
    import ShareButtons         from "./ShareButtons";

    export default {
      name: 'PortaUnAmico',
      mixins: [ TimPartyMixin ],
      components: {
        NewsletterBox,
        BasicModal,
        ShareButtons,
        ButtonBadgesModal,
        PortaUnAmicoCarousel,
        PortaUnAmicoReferral,
      },
      props: {
        apiUrl: {
          type: String,
          default: '/api/mgm/handleAction',
        },
        customContestAttivoPresentato: {
          type: Boolean,
          default: false,
          required: false
        },
        customContestHtmlPresentato: {
          type: String,
          default: null,
          required: false
        },
        customContestImagePresentato: {
          type: String,
          default: null,
          required: false
        },
        customContestAttivoPresentatore: {
          type: Boolean,
          default: false,
          required: false
        },
        customContestHtmlPresentatore: {
          type: String,
          default: null,
          required: false
        },
        customContestImagePresentatore: {
          type: String,
          default: null,
          required: false
        }
      },
      data: function() {
        return {
          redeemableRewards: {
            type: Array
          },

          leftTime: {
            days: {
              firstNumber: 0,
              secondNumber: 0,
              thirdNumber: 0
            },
            hours: {
              firstNumber: 0,
              secondNumber: 0
            },
            minutes: {
              firstNumber: 0,
              secondNumber: 0
            },
            seconds: {
              firstNumber: 0,
              secondNumber: 0
            }
          },
          codeCopied: false,
          initiative: '',
          refereeBenefit: '',
          flgEndInitiative: true,
          flgEndRedeemInitiative: true,
          customContestPresentato: {
            active: false,
            html: '',
            image: '',
          },
          customContestPresentatore: {
            active: false,
            html: '',
            image: '',
          },
          modal: {
            id: 'modal-get-badge',
            show: false,
            class_name: 'modal-sm',
            error: null,
            state: null,
            link_redirect: null,
          },
          body: null,
          showBanner: false,
          status: '',
          baseUrlShare: '',
        }

      },
      watch: {
        initiative() {
          let self = this;
          this.status = this.initiative.userInformation.userType;

          this.checkEndInitiative();
          this.checkEndRedeemInitiative();
          this.checkIfShowBanner();

          this.redeemableRewards = this.initiative.initiativeMgm.benefitList.filter(function (reward) {
            let keys = Object.keys(self.initiative.userInformation.benefitStatus);
            return keys.includes(String(reward.benefitId)) && !reward.isBenefitReferee && self.initiative.userInformation.benefitStatus[reward.benefitId] === 'REDEEMABLE';
            // return keys.includes(String(reward.benefitId));
          });
        },
        redeemableRewards() {
        },
        flgEndInitiative() {},
        flgEndRedeemInitiative() {
          this.checkIfShowBanner();
        },
        modal() {
          this.body = $('body').classes();
        },
        showBanner() {},
        // body() {
        //   if (this.body().contains('modal-open')) {
        //     $('body #link-badge').attr('href', this.modal.link_redirect);
        //   }
        // }
      },
      mounted: function() {
        this.setApiUrl(this.apiUrl);
        this.getInitiative();

        this.customContestPresentato.active = this.customContestAttivoPresentato;
        this.customContestPresentato.html = this.customContestHtmlPresentato;
        this.customContestPresentato.image = this.customContestImagePresentato;
        this.customContestPresentatore.active = this.customContestAttivoPresentatore;
        this.customContestPresentatore.html = this.customContestHtmlPresentatore;
        this.customContestPresentatore.image = this.customContestImagePresentatore;
        let getUrl = window.location;
        this.baseUrlShare = getUrl .protocol + "//" + getUrl.host;

        // this.body = $('body').classes();
      },
      created() {
        // set componenent name
        this.$root.$refs.PortaUnAmico = this;
        $('body #' + this.modal.id).show(function () {
          $('body #link-badge').attr('href', this.modal.link_redirect);
        })
      },
      methods: {
        computeTimeLeft: function(endTimestamp) {
          let self = this,
              endDate = new Date(endTimestamp * 1000); //unix timestamp multiplied by 1000(miliseconds)

            setInterval(function () {
              let currentDate = new Date();

              if (endDate > currentDate) {
                let delta = Math.abs(endDate - currentDate) / 1000;

                let days = Math.floor(delta / 86400);
                delta -= days * 86400;
                if (days >= 100) {
                  let first = Math.floor(days/10);
                  self.leftTime.days.firstNumber = first % 10;
                  self.leftTime.days.thirdNumber = Math.floor(days/100);
                  self.leftTime.days.secondNumber = days % 10;
                } else {
                  self.leftTime.days.firstNumber = Math.floor(days/10);
                  self.leftTime.days.secondNumber = days % 10;
                }

                let hours = Math.floor(delta / 3600) % 24;
                delta -= hours * 3600;
                self.leftTime.hours.firstNumber = Math.floor(hours/10);
                self.leftTime.hours.secondNumber = hours % 10;

                let minutes = Math.floor(delta / 60) % 60;
                // delta -= minutes * 60;
                self.leftTime.minutes.firstNumber = Math.floor(minutes/10);
                self.leftTime.minutes.secondNumber = minutes % 10;

                let seconds = Math.floor(delta % 60);
                self.leftTime.seconds.firstNumber = Math.floor(seconds/10);
                self.leftTime.seconds.secondNumber = seconds % 10;
              // } else {
              //   self.leftTime.days.firstNumber = 0;
              //   self.leftTime.days.secondNumber = 0;
              //   self.leftTime.hours.firstNumber = 0;
              //   self.leftTime.hours.secondNumber = 0;
              //   self.leftTime.minutes.firstNumber = 0;
              //   self.leftTime.minutes.secondNumber = 0;
              //   self.leftTime.seconds.firstNumber = 0;
              //   self.leftTime.seconds.secondNumber = 0;
              }
          }, 1000);
        },
        copyCode: function() {
          let $temp = $("<input>");
          $("body").append($temp);
          $temp.val($(".codice-amico-code").text()).select();
          document.execCommand("copy");
          $temp.remove();
          this.codeCopied = true;
          setTimeout(function() {
            this.codeCopied = false;
          }, 10000)
        },
        getInitiative: function() {
          var self = this;

          var payload = {
            action: 'getInitiative',
            access_token: this.access_token,
          };

          self.loading = true;
          this.callApi( payload, function(response) {
            self.initiative = response;
            self.setRefereeBenefit();
            self.computeTimeLeft(response.initiativeMgm.endTime);
          });
        },
        getInitiativeChild: function() {
          return this.initiative;
        },
        setRefereeBenefitChild: function() {
          return this.refereeBenefit;
        },
        setRefereeBenefit: function () {
          let self = this;

          this.initiative.initiativeMgm.benefitList.some(function (benefit) {
            if(benefit.isBenefitReferee) {
              self.refereeBenefit = benefit;
              return true;
            }
          })
        },
        getBenefitByBenefitId: function (benefitId) {
          let benefitOutput = null;

          this.initiative.initiativeMgm.benefitList.some(function (benefit) {
            if(benefit.benefitId == benefitId) {
              benefitOutput = benefit;
              return true;
            }
          })
          return benefitOutput;
        },

        checkEndInitiative: function () {
          this.flgEndInitiative = this.initiative.initiativeMgm.endTime < Math.floor(Date.now() / 1000);
        },
        checkEndRedeemInitiative: function () {
          this.flgEndRedeemInitiative = this.initiative == [];
        },
        getInfoModal: function () {
          return this.modal;
        },
        setInfoModal: function (modal) {
          this.modal = modal;
        },
        checkIfShowBanner: function () {
          let self = this;
          if (this.flgEndInitiative) {
            self.showBanner = false;
          } else if(this.status === 'REFERRAL') {
            self.showBanner = false;
          } else if (this.initiative.userInformation.benefitStatus[this.refereeBenefit.benefitId] === 'REDEEMED') {
            self.showBanner = false;
          } else if (typeof this.status === 'undefined') {
            self.showBanner = false;
          } else {
            self.showBanner = true;
          }
        },
        // closeModal: function () {
        //   this.dispatchMGMInitiative();
        //   console.log('son passato');
        // }
      },
      computed: {},
    }
</script>
